import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import type { IBatchProcessingType, IGetUnconfirmed } from '@/services/batchProcessing/fbBatch'
import { getList, getUnconfirmed } from '@/services/batchProcessing/fbBatch'
import { getQuery } from 'bv-utils'
import { putSave } from '@/models/utils'
import type { IFbBatchInfo } from '@/types/batch/facebook'

export type BatchModelState = ListModelState<IFbBatchInfo> & { id: number, counts: any, type: IBatchProcessingType};
export type BatchListModel = ListModel<BatchModelState, 'batch'>

const listState: BatchModelState = {
  ...defaultListState,
  id: 0,
  type: '',
  counts: { recharge: null, rename: null, permission: null, bm: null, pixel: null },
}

const getCounts = (params: IGetUnconfirmed) => {
  const { bindingBm, userPermission, changeName, spendCap, pixelAccount } = params || {}
  return {
    recharge: spendCap,
    rename: changeName,
    permission: userPermission,
    bm: bindingBm,
    pixel: pixelAccount,
  }
}

const BatchModel: BatchListModel = {
  namespace: 'batch',
  state: listState,
  // effects: {
  //   * list ({ params }, { call, put, select }) {
  //     const id = yield select((state: any) => state.batch.id)
  //     const requestId = id + 1
  //     yield put(putSave({ id: requestId, type: params, loading: true }))
  //     const [ data, error ] = yield call(getList, getQuery(), params)
  //     const [ counts ] = yield call(getUnconfirmed)
  //     const currentId = yield select((state: any) => state.batch.id)
  //     if (currentId === requestId) {
  //       yield put(putSave({  error, data: data ?? defaultListData, counts: getCounts(counts), loading: false }))
  //     }
  //   },
  // },
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state.batch.id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(getList, getQuery(), params)

      const currentId: number = yield select((state: any) => state.batch.id)
      if (currentId === requestId) {
        yield put(putSave({ error, data: data ?? defaultListData, loading: false }))
      }

      const [ counts ] = yield call(getUnconfirmed)
      if (currentId === requestId) {
        yield put(putSave({ counts: getCounts(counts) }))
      }
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default BatchModel
